import { c as _c } from "react/compiler-runtime";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "cn";
import { CheckIcon } from "../icons/CheckIcon";
interface CheckboxProps extends React.ComponentProps<typeof CheckboxPrimitive.Root> {}
function Checkbox(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("group relative flex size-4 shrink-0 cursor-pointer items-center justify-center", "rounded-sm border border-input bg-transparent outline-none transition-colors dark:bg-input/30", "data-[state=checked]:border-foreground data-[state=checked]:bg-foreground", "data-[state=checked]:text-background", "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40", "disabled:pointer-events-none disabled:opacity-50", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="flex items-center justify-center text-current"><CheckIcon /></CheckboxPrimitive.Indicator>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <CheckboxPrimitive.Root data-slot="checkbox" className={t1} {...props}>{t2}</CheckboxPrimitive.Root>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export { Checkbox, type CheckboxProps };